import { createSlice } from '@reduxjs/toolkit';
import { fetchPatients, updatePatientsGroup } from './Patients_Thunks.js'; 

const patientsSlice = createSlice({
  name: 'patients',
  initialState: { 
    list: [], 
    status: 'idle', 
    error: null, 
    isGroupingOn: false, 
    selectedPatientId: '', 
    isMapExpanded: false
  },
  reducers: {
    toggleGrouping: (state) => {
      state.isGroupingOn = !state.isGroupingOn;
    },
    selectPatientId: (state, action) => {
      state.selectedPatientId = action.payload;
    },
    toggleMapExpansion: (state) => {
      state.isMapExpanded = !state.isMapExpanded;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Patients
      .addCase(fetchPatients.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPatients.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = [...action.payload]; 
      })
      .addCase(fetchPatients.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload; 
      })

      // Update Patients Group
      .addCase(updatePatientsGroup.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updatePatientsGroup.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = [...action.payload];
      })
      .addCase(updatePatientsGroup.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { toggleGrouping, selectPatientId, toggleMapExpansion } = patientsSlice.actions;
export default patientsSlice.reducer;


